import { useMemo } from 'react';

import { keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, defaultColumnId, editAction } from '@Components/Grid/utils/column';

import DeleteEntityFormatter from './DeleteEntityFormatter';
import TypeFormatter from './TypeFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('typeTemplate', {
      header: 'Type',
      cell: info => <TypeFormatter info={info} />,
    }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}

export function deleteAction(info) {
  return <DeleteEntityFormatter key={keyOf(info, 'delete')} info={info} />
}
